<template>
  <div
    class="fnd-lottie"
    ref="animationElement"
    :style="{
      width: `${$props.width}px`,
      height: `${$props.width}px`,
    }"
  ></div>
</template>

<script>
import lottie from "lottie-web/build/player/lottie";

export default {
  name: "fnd-lottie",
  props: {
    src: {
      type: String,
      required: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    width: {
      // 단위 픽셀로 정했습니다. (수정 필요 시 템플릿에서 수정하셔도 됩니다)
      type: Number,
      default: 80,
    },
    height: {
      // 단위 픽셀로 정했습니다. (수정 필요 시 템플릿에서 수정하셔도 됩니다)
      type: Number,
      default: 80,
    },
  },
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.animationElement,
      loop: this.$props.loop,
      autoplay: this.$props.autoplay,
      path: this.$props.src,
    });
  },
};
</script>

<style scoped>
.fnd-lottie {
  /* 스타일 추가 필요시 작성해주세요! */
}
</style>
